export const DATA_CENTER_ACTIONS = {
    DATA_CENTER_CREATE: 'DATA_CENTER_CREATE',
    DATA_CENTER_CREATE_SUCCESS: 'DATA_CENTER_CREATE_SUCCESS',
    DATA_CENTER_CREATE_ERROR: 'DATA_CENTER_CREATE_ERROR',
    DATA_CENTER_RESET: 'DATA_CENTER_RESET',
    DATA_CENTER_LIST: 'DATA_CENTER_LIST',
    DATA_CENTER_LIST_SUCCESS: 'DATA_CENTER_LIST_SUCCESS',
    DATA_CENTER_LIST_ERROR: 'DATA_CENTER_LIST_ERROR',
};

export const FILE_HISTORY_ACTIONS = {
    FILE_HISTORY_LIST_REQUEST: 'FILE_HISTORY_LIST_REQUEST',
    FILE_HISTORY_LIST_SUCCESS: 'FILE_HISTORY_LIST_SUCCESS',
    FILE_HISTORY_LIST_ERROR: 'FILE_HISTORY_LIST_ERROR',
};

export const DATA_CENTER_FILE_REQUEST = {
    FILE_UPLOAD_REQUEST: 'FILE_UPLOAD_REQUEST',
    FILE_UPLOAD_SUCCESS: 'FILE_UPLOAD_SUCCESS',
    FILE_UPLOAD_ERROR: 'FILE_UPLOAD_ERROR',
};

export const DATA_CENTER_FILE_HEADERS = {
    FILE_HEADERS_REQUEST: 'FILE_HEADERS_REQUEST',
    FILE_HEADERS_SUCCESS: 'FILE_HEADERS_SUCCESS',
    FILE_HEADERS_ERROR: 'FILE_HEADERS_ERROR',
    ADD_COLUMN: 'ADD_COLUMN',
    REMOVE_COLUMN: 'REMOVE_COLUMN',
    UPDATE_COLUMN: 'UPDATE_COLUMN',
    UPDATE_COLUMN_VISIBILITY_REQUEST: 'UPDATE_COLUMN_VISIBILITY_REQUEST',
    UPDATE_COLUMN_VISIBILITY_SUCCESS: 'UPDATE_COLUMN_VISIBILITY_SUCCESS',
    UPDATE_COLUMN_VISIBILITY_ERROR: 'UPDATE_COLUMN_VISIBILITY_ERROR',
};

export const FILE_RECORDS_ACTIONS = {
    FILE_RECORDS_REQUEST: 'FILE_RECORDS_REQUEST',
    FILE_RECORDS_SUCCESS: 'FILE_RECORDS_SUCCESS',
    FILE_RECORDS_ERROR: 'FILE_RECORDS_ERROR',
    UPDATE_DATA_CENTER_ID: 'UPDATE_DATA_CENTER_ID',
};